import { render, staticRenderFns } from "./YesNo.vue?vue&type=template&id=15faa673&scoped=true&"
import script from "./YesNo.vue?vue&type=script&lang=js&"
export * from "./YesNo.vue?vue&type=script&lang=js&"
import style0 from "./YesNo.vue?vue&type=style&index=0&id=15faa673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15faa673",
  null
  
)

export default component.exports